/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-07 18:24:19
 * @Description: 
 */

export enum defaultLength {
  MOBILE_WIDTH = 750
}
export const FREE_TRY_DIALOG_DATA = [
  {
    "activity": "try",
    "editor": {
      "styleType": "free",
      "title": "edit_free_trial_ad_title",
      "titleFree": "edit_free_trial_ad_title_free",
      "subtitle": "edit_free_trial_ad_titleInfo",
      "descList": [
        {
          "icon": "/public/icon/free-dailog/photo-gradient.svg",
          "text": "edit_free_trial_ad_title1"
        },
        {
          "icon": "/public/icon/free-dailog/material-gradient.svg",
          "text": "edit_free_trial_ad_title2"
        },
        {
          "icon": "/public/icon/free-dailog/upload-gradient.svg",
          "text": "edit_free_trial_ad_title3"
        }
      ],
      "tips": "edit_free_trial_ad_cancel_tip",
      "upgradeBtn": "edit_free_trial_ad_ok",
      "rightImg": "/img/Go art.jpeg"
    }
  },
  {
    "activity": "discount",
    "editor": {
      "styleType": "free",
      "title": "edit_discount_ad_title",
      "titleIcon": "/public/img/free-dailog/fireworks.png",
      "subtitle": "edit_discount_ad_titleInfo",
      "descList": [
        {
          "icon": "/public/icon/free-dailog/photo-gradient.svg",
          "text": "edit_discount_ad_title1"
        },
        {
          "icon": "/public/icon/free-dailog/material-gradient.svg",
          "text": "edit_discount_ad_title2"
        },
        {
          "icon": "/public/icon/free-dailog/upload-gradient.svg",
          "text": "edit_discount_ad_title3"
        }
      ],
      "upgradeBtn": "edit_discount_ad_ok",
      "rightImg": "/img/Go art.jpeg"
    }
  }
]